module.exports = __webpack_public_path__ + "static/media/001-android.88ac64ed.svg";